/**
 * Static Product Rating Component
 */
window.ProductRating = (function() {
  
  function init() {
    addRatingToProduct();
    setupScrollToReviews();
  }

  function addRatingToProduct() {
    var productName = document.querySelector('.product-name.top-product-detail h1');
    if (!productName) return;

    var priceElement = document.querySelector('.price');
    var price = priceElement ? parseFloat(priceElement.textContent.replace(/[^0-9.]/g, '')) : 1000;
    
    var productId = window.location.pathname.split('/').pop() || 'default';
    var seed = productId.split('').reduce((a, b) => a + b.charCodeAt(0), 0);
    
    var baseReviews = Math.floor(price * 0.7 / 10);
    var reviewCount = Math.max(15, baseReviews + (seed % 50));
    
    var ratingBase = 4.0 + ((seed % 9) / 10);
    var rating = Math.round(ratingBase * 10) / 10;
    
    var fullStars = Math.floor(rating);
    var hasHalfStar = rating % 1 >= 0.5;
    var stars = '★'.repeat(fullStars) + (hasHalfStar ? '☆' : '') + '☆'.repeat(5 - fullStars - (hasHalfStar ? 1 : 0));

    var ratingHtml = `
      <div class="product-rating-overview" style="margin: 15px 0; font-size: 16px; background-color: #fefdf8; padding: 8px 12px; border-radius: 4px;">
        <div class="rating-stars" style="display: inline-flex; align-items: center; gap: 10px;">
          <div class="stars" style="color: #ffa500; font-size: 18px;">${stars}</div>
          <span class="rating-text" style="color: #666; font-size: 16px; font-weight: 600;">${rating}</span>
          <span class="reviews-link" style="color: #b53c17; cursor: pointer;">
            Read ${reviewCount} Reviews
          </span>
        </div>
      </div>
    `;

    productName.insertAdjacentHTML('afterend', ratingHtml);
  }

  function setupScrollToReviews() {
    var reviewsLink = document.querySelector('.reviews-link');
    if (reviewsLink) {
      reviewsLink.addEventListener('click', function(e) {
        e.preventDefault();
        var patronSection = document.querySelector('.patron-slider-box');
        if (patronSection) {
          patronSection.scrollIntoView({ behavior: 'smooth' });
          // Highlight the reviews section when scrolled to
          patronSection.style.backgroundColor = '#fefdf8';
          patronSection.style.padding = '15px';
          patronSection.style.borderRadius = '4px';
        }
      });
    }
  }

  return {
    init: init
  };
})();

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  ProductRating.init();
});